<template>
  <div :style="( search == true) ? 'background-color : white':''">
    <v-select
      multiple="multiple"
      :label="dd_label"
      :reduce="options => options[dd_value]"
      :options="extra['data']"
      :filterable="false"
      @input="send($event)"
      v-model="post"
      @search="searchAutocomplete"
      :disabled="disabled"
    >
      <template #search="{attributes, events}" v-if="required == true">
        <input class="vs__search" :required="!post" v-bind="attributes" v-on="events" />
      </template>
    </v-select>
  </div>
</template>

<script>
import { _ } from "vue-underscore";

export default {
  props: [
    "name",
    "validation",
    "content",
    "dropdown_name",
    "parsingTrigger",
    "parsingPostMulti",
    "search",
    "table_module"
  ],
  data() {
    return {
      post: [],
      extra: {},
      list: {},
      dd_label: "",
      dd_value: "",
    };
  },
  mounted() {
    if (this.dropdown_name == "srv_id") {
      this.dd_label = "srv_name";
      this.dd_value = "srv_id";
      this.post = this.content;
      this.list = this.content;
      this.extra["data"] = this.content;
    }
    else if (this.dropdown_name == "crs_model_id") {
      this.dd_label = "crs_model_name";
      this.dd_value = "crs_model_id";
      this.post = this.content;
      this.list = this.content;
      this.extra["data"] = this.content;
    }
  },
  watch: {
    content() {
      if (this.dropdown_name == "srv_id") {
        this.dd_label = "srv_name";
        this.dd_value = "srv_id";
        this.post = this.content;
        this.list = this.content;        
      }
      else if (this.dropdown_name == "crs_model_id") {
        this.dd_label = "crs_model_name";
        this.dd_value = "crs_model_id";
        this.post = this.content;
        this.list = this.content;        
      }
    },
    parsingTrigger(){
      this.post = "";
      this.extra = [];
      this.$emit("post", {
        name: this.name,
        value: [],
      });
    }
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
    totalPrice() {
      return 0;
    },
    valueCrsModel() {
      var res = "";
      if (typeof this.parsingPostMulti != "undefined") {
        if (
          this.parsingPostMulti.crs_model_id != "" &&
          this.parsingPostMulti.crs_model_id != undefined
        ) {
          res = this.parsingPostMulti.crs_model_id;
        }
      }
      return res;
    },
    valueCrsBrand() {
      var res = "";
      if (typeof this.parsingPostMulti !== "undefined") {
        if (typeof this.parsingPostMulti.crs_brand_id !== "undefined") {
          if (
            this.parsingPostMulti.crs_brand_id != "" &&
            this.parsingPostMulti.crs_brand_id != undefined &&
            this.parsingPostMulti.crs_brand_id != null 
          ) {
            res = this.parsingPostMulti.crs_brand_id;
          }
        }
      }
      return res;
    },

    disabled() {
      var res = false;
      if (this.table_module == 'services')
      {
        if (typeof this.parsingPostMulti != "undefined") {
          if (
            this.parsingPostMulti.crs_brand_id != "" &&
            this.parsingPostMulti.crs_brand_id != undefined
          ) {
            res = false
          }
          else
          {
            res = true
          }
        }        
      }
      return res;
    },
  },
  methods: {
    send(evt) {
      console.log(evt);
      var res = [];
      var result = [];
      for (const key in evt) {
        const element = evt[key];
        res.push({
          [this.dd_value] : element[this.dd_value],
          [this.dd_label] : element[this.dd_label],
        });
        result.push(element[this.dd_value])
      }
      this.$emit("post", {
        name: this.name,
        value: result,
      });
    },
    searchAutocomplete(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.searchDeb(loading, search, this);
      }
    },
    searchDeb: _.debounce((loading, search, vm) => {
      var params = {};

      if (vm.dropdown_name == "srv_id") {
        vm.dd_label = "srv_name";
        vm.dd_value = "srv_id";

        params = {
          ["search[srv_name]"]: search,
        };

        if (vm.valueCrsModel != "") {
          params["filter[crs_model_id]"] = vm.valueCrsModel;
        }
      }
      else if (vm.dropdown_name == "crs_model_id"){
        vm.dd_label = "crs_model_name";
        vm.dd_value = "crs_model_id";

        params = {
          ["search[crs_model_name]"]: search,
        };

        if (vm.valueCrsBrand != "") {
          params["filter[crs_brand_id]"] = vm.valueCrsBrand;
        }
      }

      vm.axios
        .get("/dropdown/autocomplete/" + vm.dropdown_name, { params: params })
        .then((response) => {
          loading(false);
          vm.extra = response.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 350),
  },
};
</script>